import { SET_CHECKPUNKTE } from "./mutations.type";
import { LADE_AUSWAHLWERTE_CHECKPUNKT } from "./actions.type";
import AppApi from "@/api/AppApi";

export default {
  namespaced: true,
  state: {
    checkpunkte: [],
  },
  mutations: {
    [SET_CHECKPUNKTE](state, val) {
      state.checkpunkte = val;
    },
  },
  actions: {
    async [LADE_AUSWAHLWERTE_CHECKPUNKT](context) {
      let response = await AppApi.get("prozess/auswahlwerte/");
      context.commit(SET_CHECKPUNKTE, response.data.checkpunkte);
    },
  },
};
